// 当前落地保留旧大屏身份；2D组态只增加归类，不复制编辑器或资源库。
export const PROJECT_TYPES = ['big_screen', 'scada2d']
export const isCanvasProjectType = type => PROJECT_TYPES.includes(type)
export const projectTypeName = type => type === 'scada2d' ? '2D组态' : '大屏'

export function projectCategories (items, type) {
  if (!isCanvasProjectType(type) || !Array.isArray(items)) throw new Error('项目分类类型无效')
  return items.filter(item => item && (item.projectType || 'big_screen') === type)
    .map(item => ({ ...item, children: projectCategories(item.children || [], type) }))
}

// 基于列表可用宽度而非整个窗口；1920桌面扣除导航后默认5列。
export function projectGridColumns (width) {
  const value = Number(width)
  return Number.isFinite(value) ? Math.max(1, Math.floor((Math.max(0, value) + 20) / 300)) : 1
}
